import { useState, useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getPercentageBarConfig } from '../utils/percentageBarConfig'

export const usePercentageBarConfig = (percentage: number) => {
  const [color, setColor] = useState<string>('gray')
  const [message, setMessage] = useState<string>('')
  const [config, setConfig] = useState<{
    color: string
    message: string
  } | null>(null)
  const location = useLocation()

  useLayoutEffect(() => {
    if (percentage !== 0) {
      const fetchDetails = async () => {
        try {
          const { color, message } = await getPercentageBarConfig(
            percentage,
            location.pathname
          )
          setConfig({ color, message })
        } catch (error) {
          console.error('Error fetching percentage bar details:', error)
        }
      }

      fetchDetails()
    }
  }, [location.pathname, percentage])

  useEffect(() => {
    if (config) {
      setColor(config.color)
      setMessage(config.message)
    }
  }, [config, percentage])

  return { color, message }
}
